module.exports = __webpack_public_path__ + "static/media/malphite.7f855d79.png";